import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Footer} from '../dialog-footer/dialog-footer';

@Component({
  selector: 'kc-confirm-dialog',
  standalone: true,
  imports: [],
  providers: [DialogService],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent implements OnDestroy, OnInit {
  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Conferma Eliminazione',
    width: '95vw',
    style: {'max-width': '800px'},
    modal: true,
    focusOnShow: false,
    templates: {
      footer: Footer
    }
  };

  message: string = 'messaggio di conferma';

  constructor(private ref: DynamicDialogRef, private config: DynamicDialogConfig) {
  }

  ngOnInit() {
    this.message = this.config.data.message;
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
